import { createFileRoute } from '@tanstack/react-router'
import { NewTeamDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import EditTeamDialog from '@/routes/_app/-dialogs/edit-team'

export const Route = createFileRoute('/@modal/teams/new')({
  staticData: { slotScope: '/_app' },
  pendingComponent: NewTeamDialogPending,
  component: NewTeamSlot,
})

function NewTeamSlot() {
  const slot = useModalSlot(Route)
  return <EditTeamDialog {...slot} />
}
